import pImg1 from '../images/testimonial/sa-tes01.jpg'
import pImg2 from '../images/testimonial/sa-tes02.jpg'
import pImg3 from '../images/testimonial/sa-tes03.jpg'
import pImg4 from '../images/testimonial/sa-tes04.jpg'
import pImg5 from '../images/project/img01.png'
import pImg6 from '../images/project/img02.png'
import pImg7 from '../images/project/img03.png'



import icon1 from '../images/icon/pro-icon01.png'
import icon2 from '../images/icon/pro-icon02.png'
import icon3 from '../images/icon/pro-icon03.png'


const Project = [
    {
        Id: '1',
        pImg: pImg1,
        title: 'Enterprise Cloud Migration Success Story',
        slug: 'enterprise-cloud-migration-success',
        rnumber: '78',
        rtext: 'System Efficiency Improvement',
        tnumber: '2.4',
        ttext: 'Annual Cloud Cost Reduction',
        snumber: '99.98',
        stext: 'Platform Uptime Achieved',
        description: 'Full-scale Azure migration with AI-driven analytics infrastructure modernization for global logistics firm.',
    },
    {
        Id: '2',
        pImg: pImg2,
        title: 'AI-Powered Supply Chain Transformation',
        slug: 'ai-supply-chain-transformation',
        rnumber: '65',
        rtext: 'Process Automation Rate',
        tnumber: '1.8',
        ttext: 'Annual Operational Savings',
        snumber: '40',
        stext: 'Faster Decision Making',
        description: 'Machine learning implementation for predictive logistics and inventory optimization.',
    },
    {
        Id: '3',
        pImg: pImg3,
        title: 'Cybersecurity Infrastructure Overhaul',
        slug: 'cybersecurity-infrastructure-overhaul',
        rnumber: '100',
        rtext: 'Threat Detection Accuracy',
        tnumber: '2',
        ttext: 'Annual Infrastructure Security Cost Savings',
        snumber: '85',
        stext: 'Faster Incident Response',
        description: 'Enterprise-grade security framework implementation with Zero Trust architecture.',
    },
    {
        Id: '4',
        pImg: pImg4,
        title: 'Legacy System Modernization Case Study',
        slug: 'legacy-system-modernization',
        rnumber: '300',
        rtext: 'Transaction Processing Speed',
        tnumber: '3.1',
        ttext: 'M Annual Maintenance Savings',
        snumber: '100',
        stext: 'System Compatibility Achieved',
        description: 'Full-stack modernization of core banking platforms with microservices architecture.',
    },
    {
        Id: '5',
        pImg: pImg5,
        icon: icon1,
        title: 'Enterprise Remote Work Infrastructure',
        slug: 'remote-work-infrastructure',
        rtext1: 'Cloud Architecture',
        rtext2: 'VPN Solutions',
        rtext3: 'Collaboration Suite',
        description: 'Secure global remote access system deployment with multi-cloud integration.',
    },
    {
        Id: '6',
        pImg: pImg6,
        icon: icon2,
        title: 'AI-Driven Customer Experience Platform',
        slug: 'ai-customer-experience',
        rtext1: 'Machine Learning',
        rtext2: 'CRM Integration',
        rtext3: 'Personalization Engine',
        description: 'Omnichannel engagement platform with predictive analytics and NLP capabilities.',
    },
    {
        Id: '7',
        pImg: pImg7,
        icon: icon3,
        title: 'DevOps Automation Implementation',
        slug: 'devops-automation',
        rtext1: 'CI/CD Pipeline',
        rtext2: 'IaC',
        rtext3: 'Cloud Native',
        description: 'Full-stack DevOps transformation with infrastructure-as-code implementation.',
    },
    {
        Id: '8',
        pImg: pImg6,
        icon: icon2,
        title: 'Enterprise Data Lake Solution',
        slug: 'enterprise-data-lake',
        rtext1: 'Big Data',
        rtext2: 'Analytics',
        rtext3: 'AI Integration',
        description: 'Petabyte-scale data infrastructure with real-time business intelligence capabilities.',
    },
    {
        Id: '9',
        pImg: pImg6,
        icon: icon2,
        title: 'IoT Manufacturing Platform',
        slug: 'iot-manufacturing-platform',
        rtext1: 'IIoT',
        rtext2: 'Predictive Maintenance',
        rtext3: 'Edge Computing',
        description: 'Industrial IoT implementation with AI-powered predictive quality control systems.',
    },
];

export default Project;